import eyeIcon from './../Assets/icons/eye 1.svg';
import editIcon from './../Assets/icons/Un-Checkbox.svg';

export const USERROLE_TABLE_HEADERS = [
 
  "Business Partner Name",
  "Vendor Type",
  "Vendor Name",
//   "Status",
  "Action"
];

export const USERROLE_TABLE_DATA = [
  { id: 1, businessPartnerName: "Partner A", vendorType: "John Doe", companyName: "companyName A", actions: "Edit/Delete" },
  { id: 2, businessPartnerName: "Partner B", vendorType: "Jane Smith", companyName: "companyName B", actions: "Edit/Delete" },
  { id: 3, businessPartnerName: "Partner C", vendorType: "Michael Johnson", companyName: "companyName C",  actions: "Edit/Delete" },
  { id: 4, businessPartnerName: "Partner A", vendorType: "John Doe", companyName: "companyName A",  actions: "Edit/Delete" },
  { id: 5, businessPartnerName: "Partner B", vendorType: "Jane Smith", companyName: "companyName B", actions: "Edit/Delete" },
  { id: 6, businessPartnerName: "Partner C", vendorType: "Michael Johnson", companyName: "companyName C",  actions: "Edit/Delete" },
  { id: 7, businessPartnerName: "Partner A", vendorType: "John Doe", companyName: "companyName A",  actions: "Edit/Delete" },
  { id: 8, businessPartnerName: "Partner B", vendorType: "Jane Smith", companyName: "companyName B",  actions: "Edit/Delete" },
  { id: 9, businessPartnerName: "Partner C", vendorType: "Michael Johnson", companyName: "companyName C",  actions: "Edit/Delete" },
  { id: 10, businessPartnerName: "Partner A", vendorType: "John Doe", companyName: "companyName A",  actions: "Edit/Delete" },
  { id: 11, businessPartnerName: "Partner B", vendorType: "Jane Smith", companyName: "companyName B",  actions: "Edit/Delete" },
  { id: 12, businessPartnerName: "Partner C", vendorType: "Michael Johnson", companyName: "companyName C",  actions: "Edit/Delete" },
  { id: 13, businessPartnerName: "Partner A", vendorType: "John Doe", companyName: "companyName A",  actions: "Edit/Delete" },
  { id: 14, businessPartnerName: "Partner B", vendorType: "Jane Smith", companyName: "companyName B", actions: "Edit/Delete" },
  { id: 15, businessPartnerName: "Partner C", vendorType: "Michael Johnson", companyName: "companyName C",  actions: "Edit/Delete" },
];

export const USERROLE_KEY_MAPPING = {
  
  "Business Partner Name": "bp_name",
  "Vendor Type": "vendor_type_name",
  "Vendor Name": "companyname",
//   "Status": "status",
  "Action": [
    { type: "edit", icon: editIcon, label: "Edit" },
    //{ type: "view", icon: eyeIcon, label: "View" }
  ]
};
